import { createAsyncThunk } from '@reduxjs/toolkit';
import { registerFastStudent } from '../../api/studentsApi';
import { RootState } from '../../redux/reducers';
import { toastr } from 'react-redux-toastr';
import { authSuccess } from '@/redux/actions/authActions';
import LocalStorageService from '@/services/LocalStorageService';
import { appError, appLoading, appSuccess } from '@/redux/actions/appActions';

interface RcAddress {
  street: string;
  postalCode: string;
  city: string;
  country: string;
}

export const registerTempUserRc = createAsyncThunk(
  'rc/registerTempUser',
  async (address: RcAddress | null, { getState, rejectWithValue, dispatch }) => {
    const state = getState() as RootState;
    const tempUser = state.user;
    const schoolName = state.rc.schoolName;

    const payload = {
      user: {
        name: tempUser.firstname,
        lastName: tempUser.lastname,
        email: tempUser.email,
        password: tempUser.password,
      },
      civility: tempUser.civility,
      address: address,
      phoneNumber: tempUser.phone,
      birthday: tempUser.birthdate,
      studentType: 'classic',
      referralCode: null,
      // Si un slug ?school=... a été détecté dans l'URL d'entrée, on l'envoie au
      // back qui rattachera le compte à l'école et appliquera le bon studentType
      // (inclusive/partner). Slug inconnu = back ignore et garde 'classic'.
      ...(schoolName ? { schoolName } : {}),
    };

    try {
      dispatch(appLoading());

      const response = await registerFastStudent(payload);
      const { token, refresh_token, data } = response.data;

      const service = LocalStorageService.getService();

      service.setToken({ token, refresh_token });
      service.setUser({ user: data });

      dispatch(authSuccess({
        data: { user: data },
        token: token
      }));

      dispatch(appSuccess());

      toastr.success(
        'Confirmation email envoyée',
        'Un email de confirmation vient de vous être envoyé.'
      );
      return response.data;
    } catch (error: any) {
      dispatch(appError());
      toastr.error(
        'Erreur',
        error?.response?.data?.message || "Erreur lors de l'inscription"
      );
      return rejectWithValue(error?.response?.data);
    }
  }
);
